import React from 'react';
import PropTypes from 'prop-types';

const PdxNavPanelSectionArticle = ({ title, description, link }) => (
  <div className="pdx-nav-panel-section-item article">
    <a href={link} className="panel-link" target="_new">{title}</a>
    <div className="pdx-nav-panel-article-description">{description}</div>
  </div>
);

PdxNavPanelSectionArticle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

export default PdxNavPanelSectionArticle;
